<template>
  <div class="question">
    <div
      class="question-text"
      :style="{
        fontFamily: poll.jsStyle.answerFont.name,
        color: poll.jsStyle.questionColor
      }"
    >{{ question.texts[lang] }}</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'question',
  props: {
    poll: Object,
    question: Object
  },
  computed: {
    ...mapGetters({ lang: 'getInputLanguage' }),
  }
};
</script>

<style lang="scss" scoped>
.question {
  text-align: center;
}

.question-text {
  background-color: #9921b1;
  border-radius: 0 15px;
  font-size: 50px;
  margin: 15px;
}
</style>
